import { BaserowPlugin } from '@baserow/modules/core/plugins'

import CopilotSidebar from '@baserow/modules/copilot/components/CopilotSidebar'
import CopilotSidebarMenuEntry from '@baserow/modules/copilot/components/CopilotSidebarMenuEntry'

import copilotChatStore from '@baserow/modules/copilot/store/chat'
import CopilotChatService from '@baserow/modules/copilot/services/chatService'

/**
 * CopilotPlugin
 *
 * Frontend plugin that integrates the Copilot sidebar into the existing
 * Baserow plugin/registry infrastructure.
 */
class CopilotPlugin extends BaserowPlugin {
  static getType() {
    return 'vokalisCopilot'
  }

  getType() {
    return CopilotPlugin.getType()
  }

  getRightSidebarWorkspaceComponents(workspace) {
    return [CopilotSidebar]
  }

  getSidebarWorkspaceComponents(workspace) {
    return [CopilotSidebarMenuEntry]
  }
}

export default defineNuxtPlugin({
  name: 'copilot',
  dependsOn: ['core', 'store'],
  setup(nuxtApp) {
    const { $store, $registry, $client } = nuxtApp
    const context = { app: nuxtApp }

    if (!$store.hasModule('copilot')) {
      $store.registerModuleNuxtSafe('copilot', copilotChatStore)
    }

    const copilotChat = new CopilotChatService($client)
    nuxtApp.provide('copilotChat', copilotChat)

    $registry.register('plugin', new CopilotPlugin(context))
  },
})
